module.exports = __webpack_public_path__ + "static/media/nav-icon-impact-narrative-active.4e95ad03.svg";